// import axios from 'axios'
import AxiosProvider from '../../providers/AxiosProvider'
import { ENABLE_CREDENTIALS_FOR_REQUEST } from '../../Constants'

export const getHealth = async () => {
  const reqURL = '/auth/healthcheck'

  const beepAxios = AxiosProvider.getBeepAxios()
  const response = await beepAxios
    .get(reqURL, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
    .catch((err) => Promise.reject(err.response.data))
  return response.data
}

export const getMaintenanceContent = async () => {
  const reqURL = '/content?contentTypes=maintenance'

  const beepAxios = AxiosProvider.getBeepAxios()
  const response = await beepAxios
    .get(reqURL, { withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST })
  return response.data.content[0].fields
}
